import type { MenuNavigationItem } from "./types";
import NavigationBanners from "./NavigationBanners";
import NavigationCategories from "./NavigationCategories";

interface Props {
  navItem: MenuNavigationItem;
  rulesBarText?: string;
}

function NavItemModal({
  navItem: { name, url, description, categories, images, borderRight },
}: Props) {
  return (
    <div
      className={`fixed inset-0 z-50 flex flex-col justify-start items-start transition-opacity duration-200 ease-linear menu-modal max-h-[350px]`}
    >
      <div className="relative w-full max-h-[350px] min-h-[350px] flex flex-row justify-between pl-29 border-t border-solid border-[#DBDBDB] bg-white z-50">
        <div className="flex w-full justify-start gap-14 pt-8 pb-8 pr-12">
          <div className="flex flex-col w-full max-w-max px-0 lg:hidden">
            <h3 className="my-[5px]">
              <a
                className="font-['Poppins'] not-italic font-normal text-lg leading-5 tracking-[0.05em] uppercase text-[#333333] no-underline"
                href={url}
              >
                {name}
              </a>
            </h3>
            <p className="font-['Poppins'] not-italic font-normal text-[13px] leading-[171.1%] text-[#434343]">
              {description}
            </p>
            <a
              className="underline font-['Poppins'] not-italic font-normal text-sm leading-[15px] normal-case text-[#434343]"
              href={url}
            >
              ver tudo em {name.toLowerCase()}
            </a>
          </div>

          {categories && (
            <NavigationCategories
              categories={categories}
              borderRight={borderRight}
            />
          )}
        </div>

        {images && <NavigationBanners images={images} itemName={name} />}
      </div>
    </div>
  );
}

export default NavItemModal;
